export default {
  errorPayments: {
    title: "Исправление и разноска ошибочных платежей",
    errorPaymentsForm: {
      modal: {
        title: "Исправление и разноска ошибочных платежей"
      },
      autoDistribute: "F2 - Автоматически разнести платеж после изменения"
    }
  }
};
